import $ from 'jquery';

export default class MobileMenu {
  constructor() {
    this.$mobileMenu = $('.mobile-navigation');
    this.addEvents();
  }

  addEvents() {
    this.$mobileMenu.on('click', '.menu-item-has-children', (e) => {
      $(e.target).toggleClass('menu-item-has-children--active');
    });

    this.$mobileMenu.on('click', 'a', (e) => {
      e.stopPropagation();
    });
  }
}
